import { Store } from '@tanstack/react-store'

export const selectedTeamsStore = new Store<string[]>([])
